<header class="station-header">
  <div class="station-logo-container">
    <a href="https://kmhd.org" target="_blank">
      <div class="kmhd-link">
        <img src="/assets/kmhd-logo.svg" alt="KMHD" title="KMHD">
      </div>
    </a>
  </div>
  <div class="app-name">
    <h1><span class="hide-on-mobile">KMHD </span>On Demand</h1>
  </div>
  <div class="donate-button-container">
    <a href="https://www.kmhd.org/give/">
      <div class="kmhd-red-bg contribute-link">
        contribute<span class="large-only"> now</span>
      </div>
    </a>
  </div>
</header>
